import { useFrame } from '@react-three/fiber';
import { useRef, useState } from 'react';

export default function CubeExplosion({ position, color = 'black', onDone }) {
	const ref = useRef(null);
	const materialRef = useRef(null);

	const [velocity] = useState(() => [
		(Math.random() - 0.5) * 0.05,
		(Math.random() - 0.5) * 0.05,
		(Math.random() - 0.5) * 0.05,
	]);

	let life = useRef(0);

	useFrame((_, delta) => {
		life.current += delta;

		if (!ref.current || !materialRef.current) return;

		// move outward
		ref.current.position.x += velocity[0];
		ref.current.position.y += velocity[1];
		ref.current.position.z += velocity[2];

		// scale up slightly
		const s = 1 + life.current * 2;
		ref.current.scale.setScalar(s);

		// fade out
		materialRef.current.opacity = Math.max(1 - life.current * 1.5, 0);

		if (life.current > 0.7) {
			onDone?.();
		}
	});

	return (
		<mesh ref={ref} position={position}>
			<boxGeometry args={[0.4, 0.4, 0.4]} />
			<meshBasicMaterial
				ref={materialRef}
				color={color}
				transparent
				opacity={1}
			/>
		</mesh>
	);
}
